import BaseViewModel from 'Common/baseViewModel';

class ViewModel extends BaseViewModel {
    constructor() {
        super();
    }
}

var vm = new ViewModel();
(async () => {
    await vm.init();
})().catch(err => console.error(err));

window.vm = vm;